import React from 'react';
import PropTypes from 'prop-types';
import WithImpressions from '../../../WithImpressions';
import Skill from './Skill';
import './style.scss';

export default function Skills({ skills, biData }) {
    if (!skills.length) { return null; }

    const seller_card_about_me_skills = {
        type: 'seller_page.show$viewport',
        seller: {
            id: biData.sellerId
        },
        group: 'seller_card_about_me_skills_impression',
        page: {
            ctx_id: biData.pageCtxId,
            component: { name: 'seller_card_about_me_skills' },
            element: {
                position: biData.position,
                type: 'button',
                metadata: 'Skills',
                text: skills.map((skill) => skill.name).toString(),
                name: 'seller_card_about_me_skills',
                visible: true
            }
        }
    };

    return (
        <WithImpressions className="skills" value={seller_card_about_me_skills}>
            <h3>{i18n.t('seller_profile.skills')}</h3>
            <ul>
                {skills.map((skill, idx) =>
                    <Skill skill={skill} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

Skills.propTypes = {
    skills: PropTypes.array,
    biData: PropTypes.object
};

Skills.defaultProps = {
    skills: [],
    biData: {}
};



// WEBPACK FOOTER //
// ./src/common/InfoPanel/SellerProfile/Skills/index.js